import { DialogEntity }             from '.';

/**
 * Define the conversation session entity.
 */
export class ConversationSessionEntity {
    public isInitState!: boolean;
    public previousDialogs!: Map<number, DialogEntity>;

    /**
     * Constructor of ConversationSessionEntity
     * 
     * @param conversationId - The user's session identifier
     * @param dialogs - The messages list associated to the conversation session
     */
    constructor(public conversationId: string,
                public currentDialog: DialogEntity) {
                    this.isInitState = true;
                    this.previousDialogs = new Map<number, DialogEntity>();
                }

    /**
     * Add a new dialog 
     * 
     * @param dialog - The new dialog to add to the coversation session
     */
    public addNewDialog(dialog: DialogEntity) {
        if (this.previousDialogs) {
           this.previousDialogs.set(this.currentDialog.timestamp, this.currentDialog);
        }
        this.currentDialog = dialog;
    }
}
